export default __webpack_public_path__ + "static/media/dashbaord_transfer_icon.5f56c9a5.svg";